import {useEffect} from 'react';

interface Props {
    snippet: string | null;
}

/**
 * Injects a provider-agnostic chat script snippet into the DOM.
 *
 * React's dangerouslySetInnerHTML does not execute injected <script> tags,
 * so we parse the snippet, recreate each script element, and append it to
 * the document body so the browser treats it as a real script.
 *
 * @return {null} This component renders nothing to the DOM.
 */
const ChatSnippet = ({snippet}: Props) => {
    useEffect(() => {
        if (!snippet?.trim()) return;

        const container = document.createElement('div');
        container.innerHTML = snippet;

        const injectedScripts: HTMLScriptElement[] = [];

        container.querySelectorAll('script').forEach((original) => {
            const script = document.createElement('script');

            Array.from(original.attributes).forEach((attr) => {
                script.setAttribute(attr.name, attr.value);
            });

            if (original.textContent) {
                script.textContent = original.textContent;
            }

            document.body.appendChild(script);
            injectedScripts.push(script);
        });
    }, []);

    return null;
};

export default ChatSnippet;
